import { EmojiModal } from "../plugin/emoji";

import { Button, ButtonContainer } from "./style";
import { ActionButton } from "./action";
import { ActionButtonCancel } from "./actionCancel";

export const InnerButtons = ({
	editor,
	container,
	action,
	actionCancel,
	useEmoji,
	additional,
	inline,
	isMultiLine,
	disabled,
	tooltipInfo,
	messageSendingInProgress,
	customMarginRight,
	...props
}) => {
	const children = [];

	if (inline) {
		for (const button of Array.isArray(additional) ? additional : []) {
			children.push(
				<Button
					{...button}
					disabled={disabled}
					noBackgroundColor
					key={button.key || `key.${children.length}`}
					onMouseDown={(event) => {
						event.preventDefault();
						event.stopPropagation();
					}}
					onMouseUp={(event) => {
						event.preventDefault();
						event.stopPropagation();
					}}
				/>
			);
		}
	}

	if (useEmoji) {
		children.push(
			<EmojiModal
				key="emojiButton"
				insertEmoji={(emoji) => editor.current.replaceWith(emoji)}
				editorRef={editor}
				disabled={disabled}
			/>
		);
	}

	if (inline && actionCancel) {
		children.push(
			<ActionButtonCancel
				key="actionButtonCancel"
				buttonKey="actionButtonCancel"
				tooltipInfo={tooltipInfo}
				editor={editor}
				{...actionCancel}
			/>
		);
	}

	if (inline && action) {
		children.push(
			<ActionButton
				key="actionButton"
				buttonKey="actionButton"
				disabled={disabled || messageSendingInProgress}
				tooltipInfo={tooltipInfo}
				editor={editor}
				{...action}
			/>
		);
	}

	return (
		<ButtonContainer
			ref={container}
			style={{
				marginRight: customMarginRight,
			}}
			isMultiLine={isMultiLine}
			absolute
			{...props}
		>
			{children}
		</ButtonContainer>
	);
};
